import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const semiyearlyReportsManagement = createApi({
    reducerPath: "semiyearlyReportsManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        semiyearlyReportsList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/semiyearly-reports`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewSemiyearlyReports: builder.mutation({
            query: (reportId) => ({
                url: `v1/${locale}/settings/semiyearly-reports/${reportId}`,
                method: "GET",
            }),
        }),

        addSemiyearlyReports: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/semiyearly-reports`,
                method: "POST",
                body: body,
            }),
        }),

        updateSemiyearlyReports: builder.mutation({
            query: ({ body, reportId }) => ({
                url: `v1/${locale}/settings/semiyearly-reports/${reportId}`,
                method: "PATCH",
                body: body,
            }),
        }),

        deleteSemiyearlyReports: builder.mutation({
            query: (reportId) => ({
                url: `v1/${locale}/settings/semiyearly-reports/${reportId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useSemiyearlyReportsListMutation,
    useDeleteSemiyearlyReportsMutation,
    useAddSemiyearlyReportsMutation,
    useViewSemiyearlyReportsMutation,
    useUpdateSemiyearlyReportsMutation,
} = semiyearlyReportsManagement;
